import {Typography} from '@mui/material';
import ReportProblemButton from './ReportProblemButton';

export default function TraceIdFeedback({traceId}: {traceId?: string}) {
    if (!traceId) return null;
    return <>
        <Typography variant="caption" display="block">Trace ID: {traceId}</Typography>
        <ReportProblemButton traceId={traceId}/>
    </>;
}
